import { Typography } from '@execonline-inc/execonline-ui';
import { NotTranslated } from '@execonline-inc/translations';
import clsx from 'clsx';
import { observer } from 'mobx-react';

interface Props {
  className?: string;
}

function FooterDivider({ className }: Props) {
  return (
    <Typography
      data-testid="footer_divider"
      className={clsx('mx-2 leading-none text-neutral-900', className)}
      variant="bodyMedium"
    >
      <NotTranslated text="|" />
    </Typography>
  );
}

export default observer(FooterDivider);
